import { Colors } from '../../../../../../themes/colors';
import CustomPortal from '../../../../../commonComponents/CustomPortal';

export const ConfirmCloseJobPopup = ({ onConfirm, onClose }) => (
  <CustomPortal
    title="Closing This Job?"
    containerStyle={{ paddingInline: 50, paddingTop: 30 }}
    textStyle={{ textAlign: 'center' }}
    cancelText="Go Back"
    submitText="Confirm"
    submitPressed={onConfirm}
    cancelPressed={onClose}
  >
    <p
      style={{
        color: Colors.neutral_500,
        fontSize: 16,
        textAlign: 'center',
      }}
    >
      This job will be permanently closed. All candidates who applied but weren’t selected will be
      automatically archived. “Confirm” to continue.
    </p>
  </CustomPortal>
);
